import React, { useState, useEffect, useContext } from "react";
import "./ProductDetails.css";
import ExploreBtn from "../../../../../../common/common-btn/explore_btn/ExploreBtn";
import InquiryModal from "../../../../../../common/inquiry_modal/InquiryModal";
import { IDS } from "../../../../../../../utils/common";
import { Context } from "../../../../../../../utils/context";
import { useParams } from "react-router-dom";
import { ProductById } from "../../../../../../../utils/apis/effects/Effects";
import Explore_Other_Products from "../Explore_Other_Products/Explore_Other_Products";
import ExperiencePower from "../../../../../../gallary_showcase/experience_power/ExperiencePower";
import CategoryTabs from "../../../../CategoryTabs";
import EffectSwiper from "../our_category_effects_Swiper/EffectSwiper";
import HaveQuestion from "../../../have_question/HaveQuestion";

export default function ProductDetails() {
  const [showInquiry, setShowInquiry] = useState(false);

   const { id } = useParams();
  
    const { IMG_URL } = useContext(Context);
  
    var HtmlToReactParser = require("html-to-react").Parser;
    var htmlToReactParser = new HtmlToReactParser();
  
    const [productinfo, setProductInfo] = useState({});
  
    const getProductInfo = async () => {
      const res = await ProductById(id);
      if (res?.success) {
        setProductInfo(res?.data || {});
      }
    };
  
    useEffect(() => {
      if (id) getProductInfo();
    }, [id]);


  return (
    <div className="effect-info-section product-details-section Solar_Power">
      <div className="container">
        <div className="info-wrapper">
          {" "}
          <div className="left ">
            <div className="img-wrapper">
              <img alt="not" src={IDS?.IMG_URL + productinfo?.image} />
            </div>
          </div>
          <div className="right ">
            {/* <h5 className="product-name"> SQUALL CO2/ T-SHIRT CANNON</h5> */}
            <h5 className="product-name">{productinfo?.name}</h5>
            <p className="desc">
              {/* SQUALL CO₂ / T-Shirt Cannon is a high-impact event device used to
              launch T-shirts, merchandise, or soft items into crowds using
              compressed CO₂ gas. It’s widely used at concerts, sports events, &
              brand activations to create excitement and audience engagement. */}
              {htmlToReactParser.parse(productinfo?.description)}
            </p>
            <div className="box">
              <div className="details-wrapper">
                {" "}
                <p className="">Manufacturer:</p>
                <p className="info">{productinfo?.manufacturer}</p>
              </div>{" "}
              <div className="details-wrapper">
                {" "}
                <p className="">Dimensions:</p>
                <p className="info">{productinfo?.dimensions}</p>
              </div>{" "}
              <div className="details-wrapper">
                {" "}
                <p className="">Weight:</p>
                <p className="info">{productinfo?.weight}</p>
              </div>{" "}
              <div className="details-wrapper">
                {" "}
                <p className="">Control Method:</p>
                <p className="info">{productinfo?.control_method}</p>
              </div>{" "}
              <div className="details-wrapper">
                {" "}
                <p className="">Consumption:</p>
                <p className="info">{productinfo?.consumption}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="wrapper-div">
          <ExploreBtn text="Inquire Now" onClick={() => setShowInquiry(true)} />
        </div>
      </div>
      <InquiryModal
        show={showInquiry}
        handleClose={() => setShowInquiry(false)}
        product_id={id}
        type="product"
      />

      <Explore_Other_Products/>
      <ExperiencePower/>
      <EffectSwiper/>
      <HaveQuestion/>
    </div>
  );
}
